/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yourunsavedchangeshavebeendiscarded5Inputs */

const en_yourunsavedchangeshavebeendiscarded5 = /** @type {(inputs: Yourunsavedchangeshavebeendiscarded5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your unsaved changes have been discarded.`)
};

const de_yourunsavedchangeshavebeendiscarded5 = /** @type {(inputs: Yourunsavedchangeshavebeendiscarded5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine nicht gespeicherten Änderungen wurden verworfen.`)
};

/**
* | output |
* | --- |
* | "Your unsaved changes have been discarded." |
*
* @param {Yourunsavedchangeshavebeendiscarded5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yourunsavedchangeshavebeendiscarded5 = /** @type {((inputs?: Yourunsavedchangeshavebeendiscarded5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yourunsavedchangeshavebeendiscarded5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yourunsavedchangeshavebeendiscarded5(inputs)
	return de_yourunsavedchangeshavebeendiscarded5(inputs)
});
export { yourunsavedchangeshavebeendiscarded5 as "yourUnsavedChangesHaveBeenDiscarded" }